import {useEffect} from "react";
import { useMap } from "react-leaflet";
import L from "leaflet";
import ReactDOM from 'react-dom'
//import leaflet button css
import './LeafletButton.css'
import Searchbar from "../searchbar/searchbar";

/**
 * Create searchbar input
 * @param props
 * @returns {*}
 */
const createSearchbarButton = (props) => {

    const ControlSearchbarButton = L.Control.extend({
        onAdd: (map) => {

            //Create the location button link
            const MySearchbarButtonLink = L.DomUtil.create("div", "searchbar-button");
            ReactDOM.render( <Searchbar map={map}/>, MySearchbarButtonLink );
            L.DomEvent.disableClickPropagation(MySearchbarButtonLink);
            return MySearchbarButtonLink;
        }
    });
    return new ControlSearchbarButton({ position: 'topright' });
}

/**
 * Add the search input on the leaflet map
 * @param props
 * @returns {null}
 * @constructor
 */
const SearchbarButton = (props) => {
    const map = useMap();
    useEffect(() => {
        //Get created searchbarButton
        const controlSearch = createSearchbarButton(props);

        //Add input to the map
        controlSearch.addTo(map);

        //Remove button on unmount to avoid duplication
        return function cleanup() {
            controlSearch._container.remove()
        }
    })

    return null;
}

export default SearchbarButton;